import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { editStockContentAction } from 'reducks/modal/actions'

const editStockContentInModal = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const edited = getState().modal.stock.edited
    if (edited) return
    dispatch(editStockContentAction())
  }
}

export default editStockContentInModal
